import React, { useEffect, useState } from 'react';
import {
    XAxis,
    YAxis,
    Tooltip,
    Legend,
    ResponsiveContainer,
    PieChart,
    Pie,
    Cell,
    LineChart,
    Line,
    CartesianGrid
} from 'recharts';
import { teacherAPI } from '../../../api/aulasApi';
import './RelatoriosAcompanhar.css';

const COLORS = {
    presentes: '#16A34A',
    ausentes: '#DC2626',
    atrasados: '#FFBB28',
};

const FrequenciaAlunosDashboard = () => {
    const [lineChartData, setLineChartData] = useState([]);
    const [pieChartData, setPieChartData] = useState([]);

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [activeTab, setActiveTab] = useState('line');

    useEffect(() => {
        const fetchDataAndProcess = async () => {
            try {
                setLoading(true);
                const response = await teacherAPI.getGraphWeekly();
                const weeklyData = response.data;

                const processedLineData = weeklyData.map(day => ({
                    name: day.dia_semana.substring(0, 3),
                    presentes: parseInt(day.presentes, 10),
                    ausentes: parseInt(day.ausentes, 10),
                    atrasados: parseInt(day.atrasados, 10),
                }));
                setLineChartData(processedLineData);

                const totals = weeklyData.reduce((acc, day) => {
                    acc.presentes += parseInt(day.presentes, 10);
                    acc.ausentes += parseInt(day.ausentes, 10);
                    acc.atrasados += parseInt(day.atrasados, 10);
                    return acc;
                }, { presentes: 0, ausentes: 0, atrasados: 0 });

                const processedPieData = [
                    { name: 'Presentes', valor: totals.presentes },
                    { name: 'Ausentes', valor: totals.ausentes },
                    { name: 'Atrasados', valor: totals.atrasados },
                ];
                setPieChartData(processedPieData.filter(item => item.valor > 0));

                setError(null);
            } catch (err) {
                console.error("Erro ao buscar dados do gráfico:", err);
                setError("Não foi possível carregar os dados do progresso.");
            } finally {
                setLoading(false);
            }
        };

        fetchDataAndProcess();
    }, []);

    if (loading) {
        return <p className="frequencia-alunos-loading">Carregando dados do progresso...</p>;
    }

    if (error) {
        return <p className="frequencia-alunos-error">{error}</p>;
    }

    return (
        <div className="frequencia-alunos-container">
            <h2 className="frequencia-alunos-title">Progresso da Turma</h2>

            <div className="frequencia-alunos-tabs">
                <button
                    className={`frequencia-alunos-tab-button ${activeTab === 'line' ? 'frequencia-alunos-tab-active' : ''}`}
                    onClick={() => setActiveTab('line')}
                >
                    Desempenho Diário
                </button>
                <button
                    className={`frequencia-alunos-tab-button ${activeTab === 'pie' ? 'frequencia-alunos-tab-active' : ''}`}
                    onClick={() => setActiveTab('pie')}
                >
                    Frequência Geral
                </button>
            </div>

            <div className="frequencia-alunos-content">
                {activeTab === 'pie' && (
                    <div className="frequencia-alunos-chart-container">
                        <ResponsiveContainer width="100%" height={350}>
                            <PieChart className="frequencia-alunos-piechart">
                                <Pie
                                    data={pieChartData}
                                    dataKey="valor"
                                    nameKey="name"
                                    cx="50%"
                                    cy="50%"
                                    outerRadius="80%"
                                    labelLine={false}
                                    label={({ name, percent, value }) => `${name}: ${value} (${(percent * 100).toFixed(0)}%)`}
                                >
                                    {pieChartData.map((entry, index) => (
                                        <Cell key={`cell-${index}`} fill={COLORS[entry.name.toLowerCase()]} />
                                    ))}
                                </Pie>
                                <Tooltip formatter={(value, name) => [`${value} alunos`, name]} />
                                <Legend />
                            </PieChart>
                        </ResponsiveContainer>
                    </div>
                )}

                {activeTab === 'line' && (
                    <div className="frequencia-alunos-chart-container">
                        <ResponsiveContainer width="100%" height={300}>
                            <LineChart data={lineChartData} margin={{ top: 20, right: 30, left: 0, bottom: 5 }}>
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis dataKey="name" />
                                <YAxis allowDecimals={false} />
                                <Tooltip />
                                <Legend />
                                <Line type="monotone" dataKey="presentes" name="Presentes" stroke={COLORS.presentes} strokeWidth={2} activeDot={{ r: 6 }} />
                                <Line type="monotone" dataKey="ausentes" name="Ausentes" stroke={COLORS.ausentes} strokeWidth={2} activeDot={{ r: 6 }} />
                                <Line type="monotone" dataKey="atrasados" name="Atrasados" stroke={COLORS.atrasados} strokeWidth={2} activeDot={{ r: 6 }} />
                            </LineChart>
                        </ResponsiveContainer>
                    </div>
                )}
            </div>
        </div>
    );
};

export default FrequenciaAlunosDashboard;